import { Injectable }       from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

import { ApiService }           from '../api/api.service';
import { ConfirmService }       from '../messages/confirm/confirm.service';
import { ProductModel }         from './typings/product';
import { ProductsFiltersModel } from './typings/products.filters';
import { TableQueryParameters } from '../table/types/table-query-parameters';

@Injectable({
  providedIn: 'root'
})
export class ProductsService {
  public broadcastKey  = 'filterProducts';
  public tableCacheKey = 'products';

  constructor (
    private apiService      : ApiService,
    private confirmService  : ConfirmService,
    private translateService: TranslateService
  ) {}

  activate ( product : ProductModel ) : Promise<any> {
    return this.confirmService.generic(this.translateService.instant('JS_SPACE.CONFIRM.ACTIVATE_PRODUCT', {
        code: product.item_code
      }))
      .then(() => this.apiService.get('/products/reactivate_product', product.id));
  }

  get ( params : TableQueryParameters, filters : ProductsFiltersModel ) : Promise<Array<ProductModel>> {
    return this.apiService.stream('/filters', [
        filters.value || '*',
        'products',
        params.offset,
        params.pageSize,
        params.field,
        params.direction,
        filters.inactiveOnly
      ]);
  }

  getCount ( filters : ProductsFiltersModel ) : Promise<number> {
    return this.apiService.get('/filters/count', [
        filters.value || '*',
        'products',
        filters.inactiveOnly
      ]);
  }
}
